export default "__VITE_ASSET__EW6GfyuY__"